export const BLOG_DIR = 'blog'
export const SANITY_STUDIO_WEB_URL =
  process.env.SANITY_STUDIO_BLOG_BASE_URL || 'http://localhost:3010'
